import { getSafe } from '../../utils/Object'
import getAbsoluteBoundingRect from '../../utils/getAbsoluteBoundingRect'
import { clamp } from '../../utils/Number'

export default
{
    name: 'app-cases-filter',

    props:
    {
        isActive: { type: Boolean, default: false }
    },

    data()
    {
        return {
            filter: this._getActiveFilter(),
            categories: [],
            cases: this.$root.content.cases.entries.filter(c => c.is_published),
            filtersItemsTotalHeight: 0
        }
    },

    created()
    {
        // Variables
        // Mousewheel
        this._isPointerDown = false
        this._pointerX = 0
        this._pointerY = 0
        this._pointerStartX = 0
        this._pointerStartY = 0
        //

        this.activeTranslateY = 0
        this.finishedTranslateY = 0

        // Get available categories
        for (let i = 0; i < this.cases.length; i += 1)
        {
            const c = this.cases[i]

            if (c.category
                && this.categories.filter(category => c.category && category._id === c.category._id).length === 0
                && !c.category.is_hidden)
            {
                this.categories.push(c.category)
            }
        }

        this.eventHub.$on('window:resize', this._onResize)
    },

    mounted()
    {
        this.$filtersContainer = this.$el.querySelector('.js-filters-container')
        this.$filtersItems = this.$el.querySelectorAll('.js-filters-item')
    },

    destroyed()
    {
        this.eventHub.$off('window:resize', this._onResize)
    },

    methods:
    {
        // EVENTS
        _onResize()
        {
            if (this.$filtersContainer)
            {
                this._filtersContainerRect = getAbsoluteBoundingRect(this.$filtersContainer)
            }

            if (this.$filtersItems)
            {
                this._filtersItemsRect = []
                this.filtersItemsTotalHeight = 0

                for (let i = 0; i < this.$filtersItems.length; i += 1)
                {
                    const item = this.$filtersItems[i]
                    const rect = getAbsoluteBoundingRect(item)
                    this.filtersItemsTotalHeight += (rect.height + rect.margins.top)
                    this._filtersItemsRect.push(rect)
                }
            }
        },

        onTouchDown(event)
        {
            if (this._goingBackToNews) return

            this._isPointerDown = true

            this._pointerStartY = event.touches[0].clientY

            this._pointerY = this._pointerStartY
        },

        onTouchMove(event)
        {
            if (!this._isPointerDown) return

            this._pointerY = event.touches[0].clientY

            if (this.$filtersContainer
                && this._filtersContainerRect)
            {
                this.activeTranslateY = this._pointerY - this._pointerStartY
                const translateY = clamp(this.finishedTranslateY + this.activeTranslateY, this.$root.height - this._filtersContainerRect.height, 0)

                this.$filtersContainer.style.transform = `translateY(${translateY}px) translateZ(0)`
            }
        },

        onTouchEnd(/* event */)
        {
            this._isPointerDown = false
            this.finishedTranslateY = this.activeTranslateY
        },

        // GETTERS
        _getActiveFilter()
        {
            let filter = null

            if (getSafe(() => this.$route.query.categorie))
            {
                // Get cases who have this filtered category
                filter = this.$route.query.categorie
            }

            return filter
        },

        // ACTIONS
        _resetFilters()
        {
            this.filter = null

            this.$router.replace(this.$root.getPageURLFromName('home'))

            this.eventHub.$emit('page-home:refresh-filter', this.filter)
        },

        _getAllFilters()
        {
            this.filter = 'all'

            this.$router.replace(`${this.$root.getPageURLFromName('home')}?categorie=${this.filter}`)

            this.eventHub.$emit('page-home:refresh-filter', this.filter)
        },

        _toggleCategoryOnFilter(slug)
        {
            this.filter = slug

            const url = this.filter ? `${this.$root.getPageURLFromName('home')}?categorie=${this.filter}` : this.$root.getPageURLFromName('home')

            this.$router.replace(url)

            this.eventHub.$emit('page-home:refresh-filter', this.filter)
        },

        // HTML ACTIONS
        _onClickOnContainer(type)
        {
            if (type === 'background'
                && this.$root.isTouch) return

            this.eventHub.$emit('page-home:hide-filters')
        }
    }
}



// WEBPACK FOOTER //
// ./src/scripts/components/app-cases-filter/script.js